import { useState, useEffect, useCallback } from "react";
import { listEvents, createEvent, updateEvent, deleteEvent, listGear, listCrew, listClients } from "@/lib/api";
import { toast } from "sonner";

export function useEventData(role) {
  const [events, setEvents] = useState([]);
  const [gear, setGear] = useState([]);
  const [crew, setCrew] = useState([]);
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const isCrew = role === "crew";

  const fetchAll = useCallback(async () => {
    try {
      // Crew may only fetch their own events + own crew profile; gear and
      // clients endpoints reject crew logins.
      const [evRes, crewRes] = await Promise.all([listEvents(), listCrew()]);
      setEvents(evRes.data);
      setCrew(crewRes.data);
      if (!isCrew) {
        const gearRes = await listGear();
        setGear(gearRes.data);
        try {
          const cRes = await listClients();
          setClients(cRes.data);
        } catch {
          toast.error("Failed to load clients");
        }
      }
    } catch {
      toast.error("Failed to load events");
    } finally {
      setLoading(false);
    }
  }, [isCrew]);

  useEffect(() => { fetchAll(); }, [fetchAll]);

  const handleCreate = async (form) => {
    await createEvent(form);
    toast.success("Event created");
    fetchAll();
  };

  const handleUpdate = async (eventId, form) => {
    await updateEvent(eventId, form);
    toast.success("Event updated");
    fetchAll();
  };

  const handleDelete = async (eventId) => {
    await deleteEvent(eventId);
    toast.success("Event deleted");
    fetchAll();
  };

  return { events, gear, crew, clients, loading, fetchAll, handleCreate, handleUpdate, handleDelete };
}
